<template>
    <b-modal v-model="vShow" :centered="centered" :hide-footer="hideFooter" :no-close-on-backdrop="noCloseOnBackdrop"
        :no-close-on-esc="noCloseOnEsc" @change="onChange" @hide="onClose" @close="onClose">
        <template v-slot:modal-header="{ close }">
            <div class="header d-flex justify-content-between w-100" :class="type">
                <h5 class="header-title">{{ title }}</h5>
                <i v-if="!noCloseButton" class="bi bi-x-circle-fill header-icon" @click="close"></i>
            </div>
        </template>
        <slot name="content">
            <p class="my-4">{{ content }}</p>
            <template v-if="footer">
                <slot name="footer">
                    <div class="footer d-flex justify-content-end flex-wrap pt-4">
                        <b-button v-if="!hideCancel" pill variant="secondary" class="btn" @click="onClose">
                            {{ cancelText }}
                        </b-button>
                        <b-button pill variant="primary" class="btn ml-2" @click="onOk">{{ okText }}</b-button>
                    </div>
                </slot>
            </template>
        </slot>
    </b-modal>
</template>
  
<script>
export default {
    name: 'Modal',
    props: {
        type: {
            type: String,
            default: "info",
        },
        title: {
            type: String,
            default: "",
        },
        content: {
            type: String,
            default: "",
        },
        show: {
            type: Boolean,
            default: false
        },
        centered: {
            type: Boolean,
            default: true
        },
        footer: {
            type: Boolean,
            default: false
        },
        hideCancel: {
            type: Boolean,
            default: false
        },
        okText: {
            type: String,
            default: "Ok",
        },
        cancelText: {
            type: String,
            default: "Cancel",
        },
        noCloseOnBackdrop: {
            type: Boolean,
            default: false,
        },
        noCloseOnEsc: {
            type: Boolean,
            default: false,
        },
        noCloseButton: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            vShow: false,
            hideFooter: true,
        }
    },
    computed: {},
    watch: {
        show: {
            handler(newVal, oldVal) {
                this.vShow = newVal
            }
        }
    },
    methods: {
        onChange(isVisible) {
            this.$emit("onChange", isVisible);
        },
        onClose() {
            this.$emit("onClose");
        },
        onOk() {
            this.$emit("onOk");
        },
    }
}
</script>
  
<style scoped lang="scss">
/deep/ .modal-content {
    border-radius: 1.25rem;
    overflow: hidden;
}

/deep/ .modal-header {
    padding: 0;
    border: none;
}

.header {
    position: relative;
    padding: 1rem 0 0;

    ::after {
        display: block;
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 1rem;
        background-color: #D2F3FF;
    }

    &-title {
        margin: 1rem;
    }

    &-icon {
        color: $secondary;
        font-size: 1.25rem;
        margin: 1rem;
    }

    &-icon:hover {
        color: $dark;
    }
}

.header.success {
    ::after {
        background-color: $success;
    }

    .header-title {
        color: $danger;
    }
}

.header.error {
    ::after {
        background-color: $danger;
    }

    .header-title {
        color: $danger;
    }
}

.btn {
    min-width: 5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/modal/Modal.vue